import { IThemeRGB } from "../../types";

export const tailwindColorTheme: IThemeRGB = {
  "rgb-primary": "24, 51, 98", // ocean-700
  "rgb-acc-1": "255, 112, 66", // coral-400
  "rgb-background-acc-1": "46, 68, 89", // storm-500
  "rgb-background-acc-start": "46, 68, 89", // storm-500
  "rgb-button-1": "39, 105, 180", // sky-600
  "rgb-link-1": "39, 105, 180", // sky-600
  "rgb-button-2": "29, 86, 150", // sky-700
  "rgb-link-2": "29, 86, 150", // sky-700
  "rgb-link-light": "109, 176, 252", // sky-300
  "rgb-code-background": "24, 51, 98", // ocean-700
};
